import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import Layout from '../../components/Layout'
import config from '../../config'
import { getNativeAds } from '../../api/nativeads'
import Button from '../../components/ui/Button'

const NativeAds = () => {

    let { id: siteId } = useParams()
    const [site, setSite] = useState({})
    const [ads, setAds] = useState({})
    const [isLoading, setLoading] = useState(true)

    /**
     * Load initial data
     */
    useEffect(() => {
        getSite(siteId)
        if (site.native_ad_location_id !== undefined) {
            fetchAds({
                location_id: site.native_ad_location_id,
                status: 'archived'
            })
        }
    }, [site])

    /**
     * Fetch ads by location
     */
    const fetchAds = async (query) => {
        try {
            const ads = await getNativeAds(query)
            setLoading(false)
            setAds(ads)
        } catch (err) {
            alert('Error, something went wrong. Please refresh and try again. Error #vna-0')
        }
    }

    /**
     * Sets site object state based off url param (id)
     */
    const getSite = (siteId) => {
        config.sites.find((site) => {
            if (site.value === siteId) {
                setSite(site)
            }
        })
    }

    return (
        <Layout>
            <div className="mb-24">
                <div className="mb-2 flex justify-between">
                    <div className="text-3xl font-semibold">
                        Archived Mobile Ads
                    </div>
                </div>
                {
                    isLoading && (
                        <div>
                            Loading Mobile Ads...
                        </div>
                    )
                }
                {
                    !isLoading && (
                        <div className="bg-white rounded shadow flex flex-col overflow-hidden">
                            {
                                ads.data && ads.data.map((ad, index) => (
                                    <Link className={`p-4 hover:bg-blue-500 flex justify-between items-center hover:text-white`} to={`/dashboard/${site.value}/nativeads/${ad.id}`}>
                                        <div>
                                            {ad.title} <span className={`ml-2 text-xs text-white uppercase rounded-full px-2 py-1 ${ad.status === 'active' ? 'bg-green-500' : 'bg-red-500'}`}>{ad.status}</span>
                                        </div>
                                        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                                    </Link>
                                ))
                            }
                        </div>
                    )
                }
            </div>
        </Layout>
    )
}

export default NativeAds